import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  const [activeCategory, setActiveCategory] = useState<string | null>(null);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 -mt-8 relative z-20">
      <div className="bg-background-100 border border-background-300/60 rounded-2xl p-4 md:p-5">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-compass-3-line text-accent-500 text-xl"></i>
          </div>
          <h2 className="text-base font-heading font-bold text-foreground-200">
            爆料分类
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2">
          <Link
            to="/"
            className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
              activeCategory === null
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-200/50 text-foreground-400 hover:text-foreground-200 hover:bg-background-200'
            }`}
            onClick={() => setActiveCategory(null)}
          >
            <i className="ri-home-line"></i>
            全部
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200/50 text-foreground-400 hover:text-foreground-200 hover:bg-background-200'
              }`}
              onClick={(e) => {
                setActiveCategory(cat.slug);
              }}
            >
              <i className={`${cat.icon}`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}